import { render, staticRenderFns } from "./privacyLogView.vue?vue&type=template&id=5b632671&"
import script from "./privacyLogView.vue?vue&type=script&lang=js&"
export * from "./privacyLogView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports